export default __webpack_public_path__ + "static/media/190629_192557_DSCN3455.ed7108e0.JPG";